import type { AiPlatformType, OtherPlatformType } from '@lighthouse/shared'

import type { IntegrationList } from './types'

export const otherPlatformIconMap: Record<OtherPlatformType, string> = {
    DING_TALK_ROBOT: 'BrandLogoDingding',
    WE_COM_ROBOT: 'BrandLogoqiyeweixin',
    WE_COM_MAIL: 'BrandLogoWeCom',
    ALIYUN_SMS: 'aliyun',
    NET_EASE_126_MAIL: 'NetEasyFree',
    WECHAT_OFFICIAL_ACCOUNT: 'WeChatLogoIconLibrary',
    WECHAT_PAY: 'WechatPay',
    STRIPE: 'Stripe',
    SEARCH_API: 'SearchAPI',
    DEEP_SEEK: 'DeepSeek',
    QWEN: 'TongYi',
    ERNIE_BOT: 'WenXin',
    ZHI_PU_AI: 'ZhiPu',
    MOONSHOT_AI: 'Moonshot',
    WECHAT_MINI_PROGRAM: 'MiniProgram'
}

export const otherPlatformNameMap: Record<OtherPlatformType, string> = {
    DING_TALK_ROBOT: '钉钉',
    WE_COM_ROBOT: '企业微信',
    WE_COM_MAIL: '腾讯企业邮箱',
    ALIYUN_SMS: '阿里云',
    NET_EASE_126_MAIL: '126网易邮箱',
    WECHAT_OFFICIAL_ACCOUNT: '微信公众号',
    WECHAT_PAY: '微信商户号',
    STRIPE: 'Stripe',
    SEARCH_API: 'Search API',
    DEEP_SEEK: 'DeepSeek',
    QWEN: '通义千问',
    ERNIE_BOT: '文心一言',
    ZHI_PU_AI: '智谱AI',
    MOONSHOT_AI: 'Moonshoot AI',
    WECHAT_MINI_PROGRAM: '小程序'
}

export const otherPlatformColorMap: Record<OtherPlatformType, string> = {
    DING_TALK_ROBOT: 'rgba(50, 150, 250, 1)',
    WE_COM_ROBOT: 'rgba(0, 130, 239, 1)',
    WE_COM_MAIL: 'rgba(40, 131, 236, 1)',
    ALIYUN_SMS: 'rgba(237, 115, 46, 1)',
    NET_EASE_126_MAIL: 'rgba(30, 126, 62, 1)',
    WECHAT_OFFICIAL_ACCOUNT: 'var(--color-green-500)',
    WECHAT_PAY: 'var(--color-green-500)',
    STRIPE: 'rgba(13, 33, 56, 1)',
    SEARCH_API: 'rgba(0, 0, 27, 1)',
    DEEP_SEEK: 'rgba(77, 107, 254, 1)  ',
    QWEN: 'rgba(96, 91, 236, 1)',
    ERNIE_BOT: 'rgba(19, 108, 214, 1)',
    ZHI_PU_AI: 'rgba(22, 121, 255, 1)',
    MOONSHOT_AI: 'var(--color-black)',
    WECHAT_MINI_PROGRAM: 'var(--color-green-500)'
}

export const otherPlatformBackgroundColorMap: Record<OtherPlatformType, string> = {
    DING_TALK_ROBOT: 'rgba(233, 242, 251, 1)',
    WE_COM_ROBOT: 'rgba(241, 245, 250, 1)',
    WE_COM_MAIL: 'rgba(240, 246, 253, 1)',
    ALIYUN_SMS: 'rgba(255, 245, 239, 1)',
    NET_EASE_126_MAIL: 'rgba(238, 255, 244, 1)',
    WECHAT_OFFICIAL_ACCOUNT: 'rgba(241, 255, 249, 1)',
    WECHAT_PAY: 'rgba(241, 255, 249, 1)',
    STRIPE: 'rgba(241, 245, 250, 1)',
    SEARCH_API: 'rgba(105, 134, 235, 1)',
    DEEP_SEEK: 'rgba(236, 239, 255, 1)',
    QWEN: 'rgba(241, 241, 255, 1)        ',
    ERNIE_BOT: 'rgba(235, 244, 255, 1)',
    ZHI_PU_AI: 'rgba(239, 245, 254, 1)',
    MOONSHOT_AI: 'rgba(1, 1, 1, 1)',
    WECHAT_MINI_PROGRAM: 'rgba(241, 255, 249, 1)'
}

export const otherPlatformDescribeMap: Record<OtherPlatformType, string> = {
    DING_TALK_ROBOT: '通过群机器人，将消息自动推送钉钉群聊的实用功能。通过这一集成，机器人可以在发送通知，有效提升办公效率。',
    WE_COM_ROBOT: '通过群机器人，将消息自动推送企业微信群聊的实用功能。通过这一集成，机器人可以在发送通知，有效提升办公效率。',
    WE_COM_MAIL: '通过腾讯企业邮箱给用户发送邮件。',
    ALIYUN_SMS: '通过阿里云短信服务给用户发送短信。',
    NET_EASE_126_MAIL: '通过126网易免费邮箱给用户发送邮件。',
    WECHAT_OFFICIAL_ACCOUNT: '集成微信是实现网页应用微信登录、自动采集微信用户信息、发送微信模版消息、网页应用微信支付等功能的前提条件。',
    WECHAT_PAY: '实现微信的发起支付和申请退款的功能；支持使用分账相关能力。',
    STRIPE: '调用 Stripe 来完成商品的支付。',
    SEARCH_API: '一个聚合搜索平台，可提供来自 Google 搜索、必应搜索、百度搜索等搜索引擎集合的结构化数据。',
    DEEP_SEEK: '由杭州深度求索公司推出的开源AI大模型，通过混合专家架构（MoE）实现高性能与低成本，在数学、代码生成等任务中表现卓越。',
    QWEN: '阿里云研发的超大规模语言模型，具备多轮对话、文案创作、逻辑推理和多语言支持能力。',
    ERNIE_BOT: '百度推出的生成式 AI 大模型，具备跨模态、跨语言的深度语义理解与生成能力，支持文学创作、商业文案、数据分析、代码生成等场景。',
    ZHI_PU_AI: '智谱AI是由清华大学团队研发的超大规模预训练模型，聚焦知识增强与多模态融合，支持多轮对话、文案生成、逻辑推理及多语言交互。',
    MOONSHOT_AI: '',
    WECHAT_MINI_PROGRAM: '微信小程序发起授权订阅消息、发送小程序服务通知和打开小程序内置地图。'
}

export const INTEGRATION_LIST: IntegrationList = [
    {
        categoryId: 'AI_MODEL',
        name: 'AI模型',
        list: [
            {
                id: '1',
                title: 'DeepSeek',
                type: 'DEEP_SEEK',
                description: otherPlatformDescribeMap['DEEP_SEEK'], // 替换为 otherPlatformDescribeMap
                tags: ['LLM'],
                isSupportConfig: true
            },
            {
                id: '2',
                title: '通义千问',
                type: 'QWEN',
                description: otherPlatformDescribeMap['QWEN'], // 替换为 otherPlatformDescribeMap
                tags: ['LLM', 'TTS', 'TEXT EMBEDDING', 'RERANK'],
                isSupportConfig: true
            },
            {
                id: '4',
                title: '智谱AI',
                type: 'ZHI_PU_AI',
                description: otherPlatformDescribeMap['ZHI_PU_AI'], // 替换为 otherPlatformDescribeMap
                tags: ['LLM', 'TEXT EMBEDDING'],
                isSupportConfig: true
            },
            // {
            //     id: '3',
            //     title: '文心一言',
            //     type: 'ERNIE_BOT',
            //     description: otherPlatformDescribeMap['ERNIE_BOT'], // 替换为 otherPlatformDescribeMap
            //     tags: ['LLM TEXT', 'EMBEDDING', 'RERANK'],
            //     isSupportConfig: true
            // },
            {
                id: '5',
                title: 'Moonshoot AI',
                type: 'MOONSHOT_AI',
                description:
                    '由清华大学团队研发，其旗舰产品 Kimi 智能助手支持 200 万字超长无损上下文处理。应用场景覆盖专业文档分析、代码开发、多轮对话等领域，可辅助用户快速掌握新领域知识。',
                tags: ['LLM'],
                isSupportConfig: true
            }
        ]
    },
    {
        categoryId: 'TOOL',
        name: '工具',
        list: [
            {
                id: '6',
                title: '微信公众号',
                type: 'WECHAT_OFFICIAL_ACCOUNT',
                description: otherPlatformDescribeMap['WECHAT_OFFICIAL_ACCOUNT'], // 替换为 otherPlatformDescribeMap
                tags: ['自媒体', '认证授权'],
                isSupportConfig: true,
                capabilityList: [
                    {
                        title: '发送模版消息',
                        description: '以消息推送的方式发送给用户，会直接出现在用户的微信聊天列表中，并触发消息通知。'
                    }
                ],
                featureList: [
                    {
                        title: '微信登录',
                        describe: '支持网页应用中使用微信登录。（微信小程序中的微信登录则不需要）'
                    },
                    {
                        title: '自动采集微信用户信息',
                        describe: '支持自动采集微信用户的OpenID信息。（微信小程序中的自动采集微信用户信息则不需要）'
                    },
                    {
                        title: '调用微信商户号',
                        describe:
                            '支持在网页应用中调用微信商户号能力，以实现发起支付、申请退款的功能。（微信小程序中调用微信商户号则不需要）'
                    }
                ]
            },
            {
                id: '14',
                title: '微信商户号',
                type: 'WECHAT_PAY',
                description: otherPlatformDescribeMap['WECHAT_PAY'], // 替换为 otherPlatformDescribeMap
                tags: ['支付', '退款', '分账'],
                isSupportConfig: true,
                capabilityList: [
                    {
                        title: '发起支付',
                        description: '通过调用微信支付提供的接口，在支付场景中调起微信支付模块完成收款。'
                    },
                    {
                        title: '申请退款',
                        description: '可通过此工具将订单的支付金额的全部或部分原路退还至用户。'
                    },
                    {
                        title: '查询单笔退款',
                        description:
                            '查询单笔退款订单，提交退款申请后，推荐每间隔1分钟调用该接口查询一次退款状态，若超过5分钟仍是退款处理中状态，建议开始逐步衰减查询频率(比如之后间隔5分钟、10分钟、20分钟、30分钟.查询一次)。'
                    },
                    {
                        title: '请求分账',
                        description: '微信订单支付成功后，商户发起分账请求，将结算后的资金分到分账接收方。'
                    },
                    {
                        title: '查询分账结果',
                        description: '发起分账请求后，可调用此工具查询分账结果。'
                    },
                    {
                        title: '查询待剩余待分金额',
                        description: '可调用此工具查询订单剩余待分金额。'
                    },
                    {
                        title: '添加分账接受方',
                        description:
                            '商户发起添加分账接收方请求，建立分账接收方列表。后续可通过发起分账请求，将分账方商户结算后的资金，分到该分账接收方。'
                    },
                    {
                        title: '删除分账接收方',
                        description: '商户发起删除分账接收方请求。删除后，不支持将接受方商户结算后的资金，分到该分账接收方。'
                    }
                ]
            },
            {
                id: '15',
                title: '微信小程序',
                type: 'WECHAT_MINI_PROGRAM',
                description: otherPlatformDescribeMap['WECHAT_MINI_PROGRAM'], // 替换为 otherPlatformDescribeMap
                tags: ['小程序授权订阅消息', '发送小程序订阅消息', '打开小程序内置地图'],
                isSupportConfig: true,
                capabilityList: [
                    {
                        title: '小程序授权订阅消息',
                        description: '在微信小程序发起授权订阅消息，需要通过动作交互触发。'
                    },
                    {
                        title: '发送小程序订阅消息',
                        description: '发送小程序订阅消息，前提是用户同意授权订阅消息。'
                    },
                    {
                        title: '打开小程序内置地图',
                        description: '使用微信内置地图查看位置。'
                    },
                    {
                        title: '跳转到微信小程序',
                        description: '跳转到其他微信小程序。'
                    },
                    {
                        title: '打开微信客服',
                        description: '打开微信客服消息聊天界面。'
                    },
                    {
                        title: '打开小程序音频播放器',
                        description: '打开小程序原生的视频播放器。'
                    },
                    {
                        title: '打开微信视频号视频',
                        description: '跳转打开微信视频号视频'
                    }
                ]
            },
            {
                id: '7',
                title: 'Search API',
                type: 'SEARCH_API',
                description: otherPlatformDescribeMap['SEARCH_API'], // 替换为 otherPlatformDescribeMap
                tags: ['搜索'],
                isSupportConfig: true,
                capabilityList: [
                    {
                        title: 'Google Search API',
                        description: '一种从 Google 搜索引擎检索答案框、知识图、片段和网页的能力。'
                    },
                    {
                        title: 'Baidu Search API',
                        description: '一种从百度搜索引擎检索答案框、知识图、片段和网页的能力。'
                    },
                    {
                        title: 'Bing Search API',
                        description: '一种从必应搜索引擎检索答案框、知识图、片段和网页的能力。'
                    }
                ]
            },
            {
                id: '9',
                title: '企业微信',
                type: 'WE_COM_ROBOT',
                description: otherPlatformDescribeMap['WE_COM_ROBOT'], // 替换为 otherPlatformDescribeMap
                tags: ['即时通讯', '企业微信机器人'],
                isSupportConfig: false,
                capabilityList: [
                    {
                        title: '机器人发送群消息',
                        description: '通过群机器人，将消息自动推送企业微信群聊的实用功能。'
                    }
                ]
            },
            {
                id: '8',
                title: '钉钉',
                type: 'DING_TALK_ROBOT',
                description: otherPlatformDescribeMap['DING_TALK_ROBOT'], // 替换为 otherPlatformDescribeMap
                tags: ['即时通讯', '钉钉自定义群机器人'],
                isSupportConfig: false,
                capabilityList: [
                    {
                        title: '机器人发送群消息',
                        description: '通过群机器人，将消息自动推送钉钉群聊的实用功能。'
                    }
                ]
            },
            {
                id: '10',
                title: '腾讯企业邮箱',
                type: 'WE_COM_MAIL',
                description: otherPlatformDescribeMap['WE_COM_MAIL'], // 替换为 otherPlatformDescribeMap
                tags: ['邮件服务'],
                isSupportConfig: true,
                capabilityList: [
                    {
                        title: '发送邮件',
                        description: '通过腾讯企业邮箱给用户发送邮件。'
                    }
                ]
            },
            {
                id: '13',
                title: '126网易免费邮',
                type: 'NET_EASE_126_MAIL',
                description: otherPlatformDescribeMap['NET_EASE_126_MAIL'], // 替换为 otherPlatformDescribeMap
                tags: ['邮件服务'],
                isSupportConfig: true,
                capabilityList: [
                    {
                        title: '发送邮件',
                        description: '通过126网易免费邮箱给用户发送邮件。'
                    }
                ]
            },
            {
                id: '12',
                title: 'Stripe',
                type: 'STRIPE',
                description: otherPlatformDescribeMap['STRIPE'], // 替换为 otherPlatformDescribeMap
                tags: ['国际支付'],
                isSupportConfig: true,
                capabilityList: [
                    {
                        title: 'Stripe支付',
                        description: '调用 Stripe 来完成商品的支付。'
                    }
                ]
            },
            {
                id: '11',
                title: '阿里云',
                type: 'ALIYUN_SMS',
                description: otherPlatformDescribeMap['ALIYUN_SMS'], // 替换为 otherPlatformDescribeMap
                tags: ['短信服务'],
                isSupportConfig: true,
                capabilityList: [
                    {
                        title: '发送短信',
                        description: '通过阿里云短信服务给用户发送短信。'
                    }
                ]
            }
        ]
    }
]

export const AI_INTEGRATION_TYPE_LIST: OtherPlatformType[] = ['DEEP_SEEK', 'QWEN', 'ZHI_PU_AI', 'ERNIE_BOT', 'MOONSHOT_AI']

// 不需要授权的集成列表
export const NO_AUTH_INTEGRATION_TYPE_LIST: OtherPlatformType[] = ['WE_COM_ROBOT', 'DING_TALK_ROBOT', 'WECHAT_MINI_PROGRAM']

// 高级版本才可以使用的集成
export const advancedOtherPlatFormList: OtherPlatformType[] = ['WECHAT_PAY', 'STRIPE', 'WE_COM_ROBOT', 'DING_TALK_ROBOT']
